import { render, staticRenderFns } from "./HelpList.vue?vue&type=template&id=303004e9&scoped=true&"
import script from "./HelpList.vue?vue&type=script&lang=ts&"
export * from "./HelpList.vue?vue&type=script&lang=ts&"
import style0 from "./HelpList.vue?vue&type=style&index=0&id=303004e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303004e9",
  null
  
)

export default component.exports